import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Button, Icon } from 'antd';

import {
  schoolInsert,
  schoolList
} from '../../../modules/school';

import SchoolListDetails from '../form/SchoolListDetails';

class AddSchoolListModal extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
		}
	}

	onClose() {
		this.setState({ 	
			step: 0,
		});
		this.props.toggleAddModal();
	}

	onAdded() {
		this.setState({ 	
			step: 0,
		});
		this.props.toggleAddModal();
		this.props.schoolList();
	}

	render() {
    const { loading } = this.state;
    const { selected } = this.props;

		return (
			<Modal
				title={<span><Icon type="file-add" /> {selected ? '編輯學校' : '新增學校'}</span>}
				visible={this.props.show}
				onCancel={()=>this.onClose()}
				footer={[
					<Button key="back" onClick={()=>this.onClose()} disabled={loading}>取消</Button>
				]}
				maskClosable={false}
				closable={(loading) ? false : true}
			>
				<SchoolListDetails data={selected} callback={()=>this.onAdded()} show={this.props.show} />
			</Modal>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		schoolInsert,
		schoolList
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(AddSchoolListModal);